/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TokenPermissionResource = {
    Scim: 'SCIM',
    ReadTimesheet: 'READ_TIMESHEET',
    ReadwriteTimesheet: 'READWRITE_TIMESHEET',
    ReadInvoice: 'READ_INVOICE',
    ReadwriteInvoice: 'READWRITE_INVOICE',
    ReadPayment: 'READ_PAYMENT',
    ReadwritePayment: 'READWRITE_PAYMENT',
    ReadProject: 'READ_PROJECT',
    ReadwriteProject: 'READWRITE_PROJECT'
} as const;
export type TokenPermissionResource = typeof TokenPermissionResource[keyof typeof TokenPermissionResource];


export function instanceOfTokenPermissionResource(value: any): boolean {
    for (const key in TokenPermissionResource) {
        if (Object.prototype.hasOwnProperty.call(TokenPermissionResource, key)) {
            // @ts-ignore
            if (TokenPermissionResource[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TokenPermissionResourceFromJSON(json: any): TokenPermissionResource {
    return TokenPermissionResourceFromJSONTyped(json, false);
}

export function TokenPermissionResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenPermissionResource {
    return json as TokenPermissionResource;
}

export function TokenPermissionResourceToJSON(value?: TokenPermissionResource | null): any {
    return value as any;
}

